'use strict';

var requirePromise = require('./requirePromise');

requirePromise();

var ES = require('es-abstract/es7');
var bind = require('function-bind');

var getPromise = function getPromise(C, handler) {
	return new C(function (resolve) {
		resolve(handler());
	});
};

var OriginalPromise = Promise;

var then = bind.call(Function.call, Promise.prototype.then);

var promiseFinally = function finally_(onFinally) {
	/* eslint no-invalid-this: 0 */

	var handler = typeof onFinally === 'function' ? onFinally : function () {};
	var C;
	var newPromise = then(
		this, // throw if IsPromise(this) is false
		function (x) {
			return then(getPromise(C, handler), function () {
				return x;
			});
		},
		function (e) {
			return then(getPromise(C, handler), function () {
				throw e;
			});
		}
	);
	C = ES.SpeciesConstructor(this, OriginalPromise); // may throw
	return newPromise;
};
if (Object.getOwnPropertyDescriptor) {
	var descriptor = Object.getOwnPropertyDescriptor(promiseFinally, 'name');
	if (descriptor && descriptor.configurable) {
		Object.defineProperty(promiseFinally, 'name', { configurable: true, value: 'finally' });
	}
}

module.exports = promiseFinally;



//////////////////
// WEBPACK FOOTER
// ./~/promise.prototype.finally/implementation.js
// module id = 282
// module chunks = 7